































import Vue from 'vue'
export default Vue.extend({
    props: {
        bgColor: {
            type: String,
            default: '#F3EEEA'
        },
        closeable: {
            type: Boolean,
            default: false
        },
        cta: {
            type: String,
            default: null
        },
        ctaCallback: {
            type: Function,
            default: null
        },
        icon: {
            type: String,
            default: 'bi-info-circle-fill'
        },
        iconColor: {
            type: String,
            default: '#E7A730'
        },
        text: {
            type: String,
            required: true
        }
    }
})
